

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import OptionsData from '@/ts/OptionsData';

@Component
export default class MobileOptionsFeed extends Vue {
    @Prop() public itemData!: OptionsData;

    constructor() {
        super();
    }

    get borderClass() {
        return {
            'hococo-selected-option': this.itemData.selected === true,
        };
    }

    public selectItem(firstParameter: any) {
        this.$store.commit(Mutations.SELECT_ITEM, firstParameter);
    }

    public viewHandler() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Options,
                viewMode: ViewModes.Options.SingleOptionView,
            });
        this.$store.commit(Mutations.UPDATE_ACTIVE_OPTION, this.itemData.id);
    }
}
